import React, { createRef } from 'react';

type Props = {
  shouldScroll: boolean;
  children: (ref: React.RefObject<any>) => React.ReactNode;
};

export class ScrollToMe extends React.Component<Props> {
  itemRef = createRef<any>();

  componentDidMount() {
    const { shouldScroll } = this.props;
    if (shouldScroll && this.itemRef.current) {
      this.itemRef.current.scrollIntoView();
    }
  }

  render() {
    return this.props.children(this.itemRef);
  }
}
